import { CommonClassNameAndTestId } from "@typings/Common";

export enum GiftAnArticleVersion {
  default = "default",
  version2 = "version2",
  version3 = "version3",
}

export type GiftAnArticleButtonProps = {
  handleClick?: () => void;
} & CommonClassNameAndTestId;
